module.exports = __webpack_public_path__ + "static/media/9.question.7e6cc4a2.mp4";